import { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';

import { EmailUpdater } from 'app/modules/UpdaterEmailForm/EmailUpdater';
import { emailUpdaterApi, EmailUpdaterParams } from 'app/modules/UpdaterEmailForm/emailUpdaterApi';
import { useHttpErrorAlert } from 'pkg/Alerts/useHttpErrorAlert';
import { HttpError } from 'pkg/httpClient/httpClient';
import { UserContext } from '../Context';

export const useEmailUpdater = () => {
  const history = useHistory();
  const setHttpErrorAlert = useHttpErrorAlert();
  const { id: quoteId } = useParams<{ id: string }>();
  const { user } = useContext(UserContext);
  const initialEmail = user?.email || '';
  const methods = useForm<EmailUpdater>({ defaultValues: { email: initialEmail ?? '' } });
  const { mutate: updateEmail, isLoading, isSuccess } = useMutation<EmailUpdater, HttpError, EmailUpdaterParams>(
    emailUpdaterApi.post,
    { onError: setHttpErrorAlert }
  );

  useEffect(() => {
    if (isSuccess) {
      const timeout = setTimeout(() => window.location.replace('/'), 10000);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [isSuccess, history]);

  const onSubmit = (data: EmailUpdater) => updateEmail({ quoteId, emailUpdater: data });

  return { methods, onSubmit, isSuccess, isLoading };
};
